import {baseRequest} from './base';

//平台活动列表
function sysList(params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/List';
  return baseRequest(tempUrl,'post',params);
}
//学校活动列表
function schoolList(params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/List';
  return baseRequest(tempUrl,'post',params);
}
//课程方活动列表
function institutionList(params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/List';
  return baseRequest(tempUrl,'post',params);
}

//新建平台活动
function sysAdd(params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/create';
  return baseRequest(tempUrl,'post',params);
}
//新建学校活动
function schoolAdd(params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/create';
  return baseRequest(tempUrl,'post',params);
}
//新建课程方活动
function institutionAdd(params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/create';
  return baseRequest(tempUrl,'post',params);
}

//平台活动详情
function sysDetail(params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/detail/'+params.id;
  return baseRequest(tempUrl,'get');
}
//学校活动详情
function schoolDetail(params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/detail/'+params.id;
  return baseRequest(tempUrl,'get');
}
//课程方活动详情
function institutionDetail(params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/detail/'+params.id;
  return baseRequest(tempUrl,'get');
}

//平台活动修改
function sysUpdate(id,params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/update/'+id;
  return baseRequest(tempUrl,'post',params);
}
//学校活动修改
function schoolUpdate(id,params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/update/'+id;
  return baseRequest(tempUrl,'post',params);
}
//课程方活动修改
function institutionUpdate(id,params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/update/'+id;
  return baseRequest(tempUrl,'post',params);
}

//平台活动上下架
function sysUpOrDown(params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/upOrDown';
  return baseRequest(tempUrl,'post',params);
}
//学校活动上下架
function schoolUpOrDown(params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/upOrDown';
  return baseRequest(tempUrl,'post',params);
}
//课程方活动上下架
function institutionUpOrDown(params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/upOrDown';
  return baseRequest(tempUrl,'post',params);
}

//平台活动删除
function sysDel(params){
  let tempUrl = '/api/pcWeb/activity/sysActivity/delete/'+params.id;
  return baseRequest(tempUrl,'post');
}
//学校活动删除
function schoolDel(params){
  let tempUrl = '/api/pcWeb/activity/schoolActivity/delete/'+params.id;
  return baseRequest(tempUrl,'post');
}
//课程方活动删除
function institutionDel(params){
  let tempUrl = '/api/pcWeb/activity/institutionActivity/delete/'+params.id;
  return baseRequest(tempUrl,'post');
}

//搜索学校
function searchSchool(params){
  let tempUrl = '/api/pcWeb/activity/schoolSearch';
  return baseRequest(tempUrl,'get',params);
}

//搜索课程方
function searchInstitution(params){
  let tempUrl = '/api/pcWeb/activity/institutionSearch';
  return baseRequest(tempUrl,'get',params);
}

export default {
  sysList,schoolList,institutionList,sysAdd,schoolAdd,institutionAdd,sysDetail,schoolDetail,institutionDetail,sysUpdate,schoolUpdate,institutionUpdate,sysUpOrDown,schoolUpOrDown,institutionUpOrDown,sysDel,schoolDel,institutionDel,searchSchool,searchInstitution
}
